import { BaseRoutes } from './base.routes.constants';

export class ContatoRoutes extends BaseRoutes {
  constructor(route: string) {
    super(route);
  }
}
